import { render, staticRenderFns } from "./StudentDataDownload.vue?vue&type=template&id=3e069df5&scoped=true"
import script from "./StudentDataDownload.vue?vue&type=script&lang=js"
export * from "./StudentDataDownload.vue?vue&type=script&lang=js"
import style0 from "./StudentDataDownload.vue?vue&type=style&index=0&id=3e069df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e069df5",
  null
  
)

export default component.exports